module.exports = __webpack_public_path__ + "img/recently_deleted_check.ee3c54aa.svg";